interface QuickAction {
  icon: string;
  label: string;
}

const quickActions: QuickAction[] = [
  { icon: "ri-file-text-line", label: "Academic review" },
  { icon: "ri-slideshow-3-line", label: "Research deck" },
  { icon: "ri-layout-3-line", label: "Poster layout" },
  { icon: "ri-image-2-line", label: "Visual assets" },
  { icon: "ri-search-eye-line", label: "Literature search" },
];

export default function QuickActions() {
  return (
    <div className="mt-5 flex max-w-3xl flex-wrap items-center justify-center gap-2">
      {quickActions.map((action) => (
        <button
          key={action.label}
          className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-3.5 py-2 text-xs font-medium text-muted-foreground shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground"
        >
          <i className={`${action.icon} text-xs`} />
          {action.label}
        </button>
      ))}
    </div>
  );
}
